module.exports = __webpack_public_path__ + "img/catering-variat.62514584.png";